<template>
  <v-layout row wrap>
    <v-flex xs12 md8>
      <h2 class="display-1 mb-3">iOS Mobile App Upload</h2>
    </v-flex>
    <v-flex xs12 md8>
      <v-card>
        <v-card-title>
          <span class="title">Browse new app version and upload</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card>
          <form @submit.prevent="formSubmit">
            <v-card-text>
              <v-container fluid grid-list-xl class="ma-0 pa-0">
                <v-layout row wrap>
                  <v-text-field
                    prepend-icon="attach_file"
                    single-line
                    v-model="filename"
                    label="File uploader"
                    required
                    @click.native="onFocus"
                    ref="fileTextField"
                  ></v-text-field>
                  <input type="file" accept=".ipa" ref="fileInput" @change="onFileChange">
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="default" to="/dashboard">cancel</v-btn>
              <v-btn
                dark
                color="accent"
                @click="onUpload"
                :loading="getLoading"
                :disable="getLoading"
              >upload</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      filename: '',
      selectedFile: null
    }
  },
  watch: {
    value(v) {
      this.filename = v
    }
  },
  mounted() {
    this.filename = this.value
  },
  computed: {
    ...mapGetters(['getResponse', 'getLoading'])
  },
  methods: {
    ...mapActions(['uploadApp']),
    onFocus() {
      if (!this.disabled) {
        this.$refs.fileInput.click()
      }
    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0]
      console.log(this.selectedFile)
      this.filename = this.selectedFile.name
    },
    onUpload() {
      if (this.selectedFile) {
        this.uploadApp({ name: 'file', file: this.selectedFile }).then(() => {})
      }
    }
  }
}
</script>
<style scoped>
input[type='file'] {
  position: absolute;
  left: -99999px;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile-app/MobileUpload.vue